"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SvcBillingAutomationHttpError = void 0;
const http_status_codes_1 = __importDefault(require("http-status-codes"));
const SvcBillingAutomationError_1 = require("../SvcBillingAutomationError");
class SvcBillingAutomationHttpError extends SvcBillingAutomationError_1.SvcBillingAutomationError {
    constructor(code, message, previous) {
        super(message, previous);
        this.code = code;
        this.statusCode = http_status_codes_1.default.getStatusText(this.code);
    }
}
exports.SvcBillingAutomationHttpError = SvcBillingAutomationHttpError;
//# sourceMappingURL=SvcBillingAutomationHttpError.js.map